/**
 * Owner fleet pricing tiers. Thin wrapper around the shared FleetTiersScreen
 * using the owner's own API client. The admin owner-twin lives at
 * app/admin/owner/[id]/fleet-tiers.tsx and renders the same component.
 */
import React from 'react';
import { apiGet, apiPost, apiPatch, apiDelete } from '../../../src/api/client';
import FleetTiersScreen, { type TierApiClient } from '../../../src/screens/FleetTiersScreen';

const ownerClient: TierApiClient = {
  get: apiGet,
  post: apiPost,
  patch: apiPatch,
  delete: apiDelete,
};

export default function PricingTiersScreen() {
  return <FleetTiersScreen client={ownerClient} />;
}
